export default {
  PHYSICAL: 'physical',
  ONLINE: 'online',
  BOTH: 'physical_online'
};
